import { render, staticRenderFns } from "./WorkbenchConfig.vue?vue&type=template&id=324c1aff"
import script from "./WorkbenchConfig.vue?vue&type=script&lang=js"
export * from "./WorkbenchConfig.vue?vue&type=script&lang=js"
import style0 from "./WorkbenchConfig.vue?vue&type=style&index=0&id=324c1aff&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports